export const PKG_NAME = "@hpcc-js/comms";
export const PKG_VERSION = "3.7.6";
export const BUILD_VERSION = "3.9.0";
